<template>
  <div class="subvenciones-page">
    <Header />
    <div class="container">
      <div class="title">{{ $t('legal.subvenciones.titulo') }}</div>
      <div class="description" v-html="$t('legal.subvenciones.descripcion')"></div>
      <div class="img-subvencion">
        <img src="../../assets/subvencion.png" alt="" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../header.vue'
import Footer from '../footer.vue'

export default {
  name: 'Subvenciones',
  components: {
    Header,
    Footer
  },
  mounted () {
    this.$nextTick(() => {
      document.querySelector('.subvenciones-page').scrollIntoView()
    })
  }
}
</script>

<style lang="scss" scoped>
.subvenciones-page {
  text-align: left;
  color: #444D67;

  .container {
    padding-top: 120px;
    padding-bottom: 100px;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
      font-weight: 700;
      font-size: 28px;
    margin-bottom: 60px;
  }

  .description {
    font-size: 16px;
    line-height: 150%;

    h2 {
      margin: 0 0 15px;
    }

    h3 {
      margin-bottom: 10px;
    }
  }

  .img-subvencion {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/legal/subvenciones.vue